/* eslint import/prefer-default-export: 0 */
export const serviceConfig = {
  resourceBaseAddress: "https://prd-api-go-nl.groupm.com/api"
};
